'use client';

import { useMemo } from 'react';
import { useStore } from 'zustand';

import { cartStore } from '@/store/cart/cart.store';
import { CartItem } from '@/types/cart.types';
import { getCartCouponDiscountTotal, getCartTotal } from '@/utils/cart/get-cart-total.util';

export interface UseCartResult {
  items: CartItem[];
  itemCount: number;
  total: number;
  couponDiscount: number;
  isLoading: boolean;
  hasError: boolean;
  isEmpty: boolean;
  hasItems: boolean;
}

export function useCart(): UseCartResult {
  const cart = useStore(cartStore, (state) => state.cart);
  const status = useStore(cartStore, (state) => state.status);

  const items = useMemo(() => cart?.items ?? [], [cart]);
  const total = useMemo(() => getCartTotal(items), [items]);
  const couponDiscount = useMemo(() => getCartCouponDiscountTotal(items), [items]);

  return {
    items,
    itemCount: items.length,
    total,
    couponDiscount,
    isLoading: status === 'idle' || status === 'loading',
    hasError: status === 'error',
    isEmpty: status === 'loaded' && items.length === 0,
    hasItems: status === 'loaded' && items.length > 0,
  };
}
